export default __webpack_public_path__ + "static/media/la_ferte-vidame07.aef0606c.jpg";